import React from 'react';
import BannersTable from '../components/BannersTable';

export function Banners() {
  return <BannersTable />;
}
